import { useState } from "react";
import { services } from "../data";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    service: "",
    date: "",
    time: "",
    message: "",
  });

  const updateField = (field, value) => setForm((current) => ({ ...current, [field]: value }));

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    window.setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <>
      <PageHero
        eyebrow="Book an Experience"
        title="Reserve Your Appointment."
        desc="Fill in your details and we'll confirm within 24 hours."
        image="https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=1700&auto=format&fit=crop&q=76"
      />

      <section className="section-pad contact-section">
        <div className="container contact-grid">
          <Reveal>
            <p className="section-eyebrow">Contact</p>
            <h2 className="section-title">Start with one simple request.</h2>
            <p className="section-desc">Our team will call you back within 24 hours to confirm your appointment.</p>

            <div className="contact-card bits-spotlight">
              <img
                src="https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?w=900&auto=format&fit=crop&q=74"
                alt="Orchid Salon"
              />
              <ul>
                <li><strong>Find Us</strong><span>Orchid Salon & Academy, Bengaluru, Karnataka, India</span></li>
                <li><strong>Call Us</strong><span>+91 XXXXX XXXXX</span></li>
                <li><strong>Email</strong><span>hello@orchidsalon.in</span></li>
                <li><strong>Hours</strong><span>Mon-Sat: 10 AM - 8 PM / Sunday: 11 AM - 6 PM</span></li>
              </ul>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <form className="appointment-form bits-spotlight" onSubmit={handleSubmit}>
              {submitted ? (
                <div className="form-success">
                  <span>*</span>
                  <h3>Request Received!</h3>
                  <p>Our team will call you back within 24 hours to confirm your appointment.</p>
                </div>
              ) : (
                <>
                  <h3>Book Your Session</h3>
                  <p>Fill in your details and we'll confirm within 24 hours.</p>

                  <div className="form-row">
                    <label>
                      <span>Full Name</span>
                      <input type="text" placeholder="Your name" value={form.name} onChange={(event) => updateField("name", event.target.value)} />
                    </label>
                    <label>
                      <span>Phone Number</span>
                      <input type="tel" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={(event) => updateField("phone", event.target.value)} />
                    </label>
                  </div>

                  <label>
                    <span>Email Address</span>
                    <input type="email" placeholder="your@email.com" value={form.email} onChange={(event) => updateField("email", event.target.value)} />
                  </label>

                  <label>
                    <span>Service</span>
                    <select value={form.service} onChange={(event) => updateField("service", event.target.value)}>
                      <option value="" disabled>Select a service...</option>
                      {services.map((service) => <option key={service.id} value={service.id}>{service.name}</option>)}
                      <option value="multiple">Multiple Services</option>
                    </select>
                  </label>

                  <div className="form-row">
                    <label>
                      <span>Preferred Date</span>
                      <input type="date" value={form.date} onChange={(event) => updateField("date", event.target.value)} />
                    </label>
                    <label>
                      <span>Preferred Time</span>
                      <input type="time" value={form.time} onChange={(event) => updateField("time", event.target.value)} />
                    </label>
                  </div>

                  <label>
                    <span>Message (Optional)</span>
                    <textarea placeholder="Any special requirements..." rows={4} value={form.message} onChange={(event) => updateField("message", event.target.value)} />
                  </label>

                  <button type="submit" className="btn-primary full-width bits-magnetic">
                    <span>Send Appointment Request</span>
                  </button>
                </>
              )}
            </form>
          </Reveal>
        </div>
      </section>
    </>
  );
}
